import { ILopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/ILopTinChiSelectRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { ILopTinChiViewModel } from './../../../model/respone/lop-tin-chi/ILopTinChiViewModel';

export const eLopTinChiKetQuaActionsObj = {
  LOAD_START: {} as ILopTinChiSelectRequest,
  LOAD_SUCCESS: {} as ILopTinChiViewModel[],
  LOAD_ERRR: "",
  CHANGE_FILTER: {} as ILopTinChiSelectRequest,
  CHANGE_SELECTED_IDS: {} as number[],
  CHANGE_LOPTINCHI_ID_VIEW: 0


};
export const eLopTinChiKetQuaActionIds = generateActionTypeIds(
  eLopTinChiKetQuaActionsObj,
  "LOP_TIN_CHI_KET_QUA"
);
export type ILopTinChiKetQuaActionTypes = IGenericActionType<
  typeof eLopTinChiKetQuaActionsObj,
  "LOP_TIN_CHI_KET_QUA"
>;
